import posthog from 'posthog-js'

// 🔑 Paste your PostHog Project API key here (starts with phc_...)
const POSTHOG_KEY = 'phc_ks2NQ7b9ebYqcFiwL6H7374WAsYu59dYXWcUYVu9JYCg'

// 🌎 Use 'https://us.i.posthog.com' for US Cloud, 'https://eu.i.posthog.com' for EU Cloud
const POSTHOG_HOST = 'https://us.i.posthog.com'

let initialized = false

export function initPostHog() {
  if (initialized) return
  if (!POSTHOG_KEY || POSTHOG_KEY === 'YOUR_POSTHOG_API_KEY') {
    console.warn('[PostHog] Skipping init — API key not set in lib/posthog.ts')
    return
  }
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false, // We track pageviews manually on route change
    capture_pageleave: true,
  })
  initialized = true
}

export { posthog }
